/**
 *
 * AppliedFilterList
 *
 */

import React, { memo } from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';
import CustomIcon from '../CustomIcons';
function AppliedFilterList(props) {
  const { removeFilter, filtersForDislay } = props;

  // regex for checking the email
  const regex = new RegExp(
    /^[a-zA-Z0-9.+-_]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
  );

  return (
    <div className="applied-filters">
      {filtersForDislay.map(obj => (
        <div className="filter" key={obj.value}>
          {obj.displayText}
          {/* eslint-disable-next-line */}
          <div
            className="close-icon"
            onClick={removeFilter({
              key: obj.key,
              val: obj.value,
              subFilterKey: obj.subFilter || '',
            })}
            data-event-name="Icon_Close"
            data-ignore-inner-text="true"
            // check here if the value matches - /^[a-zA-Z0-9.+-_]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
            // then mask it otherwise let it be
            data-event-properties={JSON.stringify({
              value: regex.test(obj.value) ? 'Some email' : obj.value,
            })}
          >
            <CustomIcon componentName="CLOSE_SMALL" />
          </div>
        </div>
      ))}
    </div>
  );
}

AppliedFilterList.propTypes = {
  removeFilter: PropTypes.func,
  filtersForDislay: PropTypes.array,
};

export default memo(AppliedFilterList);
